import { ApiService, toResult } from '~/shared/api'
import type { ApiResultResponse } from '~/shared/types/api'

export class CareerRoutesCategoryService extends ApiService {
  readonly url: string = '/api/v1/yavagro/career-routes/directions'

  public getCategories<T>(): Promise<T> {
    return this.http.request<ApiResultResponse<T>>({ url: this.url }).then(toResult())
  }
}
